import { useState, useCallback } from "react";

export default function useFlag(name) {
  const [active, setActive] = useState(() => !!localStorage.getItem(`flag:${name}`) ?? false);

  const setFlag = useCallback((state) => {
    const key = `flag:${name}`;
    if (!state) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, "1");
    }

    setActive(!!state);
  }, [name]);

  return { active, setState: setFlag, name };
}
